export default class AssetGroup
{
    constructor() {
      this.description = ''
      this.risk_id = ''
      this.asset_types = []
    }
}
